import o from "dayjs";
import a from "dayjs/plugin/localizedFormat";
import d from "decimal.js";
import { getIn as s } from "formik";
import { useState as m } from "react";
const A = (n, r) => (n ?? "").localeCompare(r ?? "", void 0, { numeric: !0 }), b = (n, r) => (r ?? "").localeCompare(n ?? "", void 0, { numeric: !0 }), f = 864e13, M = (n, r) => o(n ?? f).diff(o(r ?? f)), _ = (n, r) => o(r ?? f).diff(o(n ?? f));
o.extend(a);
function h(n) {
  var r;
  (r = window.open(n, "_blank", "noreferrer")) == null || r.focus();
}
function v(n, r) {
  return s(r.touched, n) && s(r.errors, n);
}
function N(n) {
  return n ?? void 0;
}
function S(n) {
  const r = o().diff(n, "year");
  return Number.isNaN(r) || r < 0 ? 0 : r;
}
function i(n, r) {
  return n ? r : "";
}
function F(n) {
  if (n === "F")
    return "Female";
  if (n === "M")
    return "Male";
}
function u(n) {
  return n == null ? void 0 : n.toLowerCase().split(" ").reduce(
    (r, t, e) => `${r}${i(e !== 0, " ")}${t.charAt(0).toUpperCase() + t.slice(1)}`,
    ""
  );
}
function I(n, r) {
  if (n && r)
    return u(`${n} ${r}`);
  if (n)
    return u(n);
  if (r)
    return u(r);
}
function P(n, r) {
  if (n && r)
    return u(`${n}, ${r}`);
  if (n)
    return u(n);
  if (r)
    return u(r);
}
function Y(n, r, t) {
  if (n && r && t)
    return `${n}, ${r} ${t.trim().length === 9 ? `${t.substring(0, 5)}-${t.substring(5, 9)}` : t}`;
}
const $ = /^(1?)([0,2-9])(\d{2})(\d{3})(\d{4})(\d*)$/;
function y(n) {
  const r = `${n}`.replace(/\D/g, ""), t = $.exec(r);
  if (!t)
    return;
  const e = i(!!t[1], `${t[1]} `), c = i(!!t[6], ` ext. ${t[6]}`);
  return `${e}(${t[2]}${t[3]}) ${t[4]}-${t[5]}${c}`;
}
const D = {
  /** MM/DD/YYYY */
  DATE: "L",
  /** MMMM D, YYYY */
  DATE_MEDIUM: "LL",
  /** dddd, MMMM D, YYYY */
  DATE_LONG: "dddd, LL",
  /** MM/DD/YYYY hh:mm A */
  DATE_TIME: "L LT",
  /** dddd, MMMM D, YYYY h:mm A */
  DATE_TIME_LONG: "LLLL",
  /** YYYY-MM-DD */
  HYPHEN_DATE: "YYYY-MM-DD",
  /** hh:mm A */
  TIME: "LT",
  /** hh:mm A M/D/YY */
  TIME_DATE_SHORT: "LT M/D/YY"
};
function C(n, r = D.DATE) {
  return n ? o(n).format(r) : void 0;
}
const x = (n, r) => {
  if (r && n) {
    const t = Math.abs(o(r).diff(n, "day"));
    if (t > 0)
      return `${t} day${i(t !== 1, "s")}`;
    const e = Math.abs(o(r).diff(n, "hour"));
    if (e > 0)
      return `${e} hour${i(e !== 1, "s")}`;
    const c = Math.abs(o(r).diff(n, "minutes"));
    return `${c} minute${i(c !== 1, "s")}`;
  }
  return "";
};
function G(n, r = 2) {
  return n != null && !Number.isNaN(n) ? Number(n).toLocaleString(void 0, { maximumFractionDigits: r }) : void 0;
}
function H(n, r = 2, t) {
  return n != null && !Number.isNaN(n) ? Number(n).toLocaleString(void 0, {
    style: "percent",
    maximumFractionDigits: r,
    minimumFractionDigits: t
  }) : void 0;
}
function U(n) {
  return n == null ? n : d.mul(Number(n), 100).toDP(2).toNumber();
}
const R = (n, r, t) => {
  const e = n == null ? void 0 : n[r ?? ""];
  return t == null ? e == null ? void 0 : e.description : (t ? e == null ? void 0 : e.brandDescription : e == null ? void 0 : e.genericDescription) ?? (e == null ? void 0 : e.description);
}, X = (n = 750) => {
  const [r, t] = m();
  return (e) => {
    r && clearTimeout(r), t(setTimeout(() => e(), n));
  };
};
export {
  D as DateFormats,
  $ as PHONE_NUMBER_REGEX,
  G as addCommas,
  U as calcBidPercentage,
  u as capitalizeString,
  i as conditionalString,
  Y as formatAddress,
  C as formatDate,
  F as formatGender,
  I as formatNameFirstLast,
  P as formatNameLastFirst,
  H as formatPercentageString,
  y as formatPhoneNumber,
  S as getAge,
  R as getProductName,
  x as getTimeDiffStr,
  v as getValidationMessage,
  N as nullToUndefined,
  h as openInNewTab,
  A as sortAsc,
  M as sortDateAsc,
  _ as sortDateDesc,
  b as sortDesc,
  X as useDebouncedFunction
};
//# sourceMappingURL=index.js.map
